import React from 'react';

interface PreviewData {
  [key: string]: string;
}

interface DataPreviewProps {
  data: PreviewData[];
  columns: string[];
}

const DataPreview: React.FC<DataPreviewProps> = ({ data, columns }) => {
  // Use the actual file header keys when we have data — these come from
  // Papa.parse and preserve the file's original column order. The `columns`
  // prop is kept as a fallback for the empty-state header so the prop
  // signature and call sites stay unchanged.
  const fileColumns = data.length > 0 ? Object.keys(data[0]) : [];
  const displayColumns = fileColumns.length > 0 ? fileColumns : columns;
  const rowCount = data.length;

  return (
    <div className="admin-bulk-upload-preview-section">
      <h3 className="admin-bulk-upload-preview-title">Data Preview</h3>
      <p className="admin-bulk-upload-preview-subtitle">
        {rowCount > 0
          ? `Showing all ${rowCount} ${rowCount === 1 ? 'row' : 'rows'} from your file`
          : 'No rows to preview'}
      </p>

      <div className="admin-bulk-upload-preview-scroll">
        <table className="admin-bulk-upload-preview-table">
          <thead>
            <tr>
              <th className="admin-bulk-upload-preview-rownum">#</th>
              {displayColumns.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td className="admin-bulk-upload-preview-rownum">{index + 1}</td>
                {displayColumns.map((col) => (
                  <td key={col} title={row[col] ?? ''}>{row[col] ?? ''}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataPreview;
